import '../styles/search-modal-content.css'
import React from 'react';

import constants from '../constants';

import AddressSearchInputComponent from '../components/address-search-input';


class AddressSearch extends React.Component {
    render() {
        return (
            <div className="address-search">
                <div className='titleArea'>
                    <img src="/fireicon.svg" alt="fireIcon" className='icon' />
                    <div className='description' >
                        <h2 className='Oswald uppercase'>Where To?</h2>
                        <p className="Roboto">Welcome to the Utah {constants.appName}! Enter an address or location you're interested in to begin viewing nearby wildfire history in that area.</p>
                    </div>
                </div>
                <AddressSearchInputComponent onAddressInputChange={this.props.onAddressInputChange} hoist={this.props.hoist} onLocationFound={this.props.onLocationFound} />
            </div>
        );
    }
}

export default AddressSearch;


